module.exports = __webpack_public_path__ + "static/media/stats_icon_banner.f205db89.svg";